import Cookies from 'js-cookie';

let isThirdparty = null;

function handleThirdparty() {
  if (typeof Cookies.get('mea-cb-thirdparty') != 'undefined' && String(Cookies.get('mea-cb-thirdparty')) == 'true') {
    return true;
  } else if (window.location.hash == '#accept-thirdparty') {
    history.replaceState(null, null, ' ');
    return true;
  }

  return false;
}

export function thirdparty() {
  if (isThirdparty === null) {
    isThirdparty = handleThirdparty();
  }

  return isThirdparty;
}




// WEBPACK FOOTER //
// ./scripts/components/thirdparty.js